<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Portfolio</h3>
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Portfolio</li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Websites</li>

            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img
                src="assets/img/inner-banner/banner-shape1.png"
                alt="Images"></div>
        <div class="shape-two"><img
                src="assets/img/inner-banner/banner-shape2.png"
                alt="Images"></div>
        <div class="shape-three"><img
                src="assets/img/inner-banner/banner-shape3.png"
                alt="Images"></div>
        <div class="inner-banner-dots"><img
                src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="case-study-area pt-50 pb-70">
    <div class="container">
        <div class="row">

            <div class="col-lg-8 col-md-12">
                <div class="row">

             
                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/11.png"
                                    alt="Detection Project">
                         
                            <div class="content">
                                <h3><a href="https://deltalabsqatar.com/">
                                       DELTA INTL. LABS QATAR</a></h3>
                         
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/1.png"
                                    alt="Customer Segmentation">
                           
                            <div class="content">
                                <h3><a href="https://vinsuae.com/">VELOCITY FITOUTS ABUDHABI
                                        </a></h3>
                                
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/19.png"
                                    alt="Detection Project">
                           
                            <div class="content">
                                <h3><a href="https://nishikandhpadur.com/">NISHIKANDH PADUR</a></h3>
                             
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/2.png"
                                    alt="Detection Project">
                           
                            <div class="content">
                                <h3><a href="https://desertrose-qatar.com/">DESERT ROSE QATAR
                                        </a></h3>
                                
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/6.png"
                                    alt="Customer Segmentation">
                         
                            <div class="content">
                                <h3><a href="https://ipromisesolutions.com/">beFORE </a></h3>
                               
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/5.png"
                                    alt="Detection Project">
                          
                            <div class="content">
                                <h3><a href="https://gksbuilders.com/">GKS Builders </a></h3>
                               
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/18.png"
                                    alt="Customer Segmentation">
                         
                            <div class="content">
                                <h3><a href="https://sialglobal.in/">
                                    SIAL GLOBAL QATAR</a></h3>
                              
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/3.png"
                                    alt="Detection Project">
                          
                            <div class="content">
                                <h3><a href="https://contrahelp.com/"
                                        >CONTRAHELP BUSINESS
                                        </a></h3>
                          
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/12.png"
                                    alt="Customer Segmentation">
                           
                            <div class="content">
                                <h3><a href="https://sanmedgroup.in/">
                                   SANMED GROUP</a></h3>
                              
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/13.png"
                                    alt="Detection Project">
                         
                            <div class="content">
                                <h3><a href="https://perinkulamkrishnatemple.com/"
                                        >PERINKULAM TEMPLE
                                        </a></h3>
                          
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/15.png"
                                    alt="Customer Segmentation">
                          
                            <div class="content">
                                <h3><a href="https://sproutcfo.com/">
                                    SPROUT CFO</a></h3>
                              
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/14.png"
                                    alt="Detection Project">
                           
                            <div class="content">
                                <h3><a href="https://unnisrentals.com/"
                                        >UNNIS RENTALS
                                        </a></h3>
                          
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/16.png"
                                    alt="Customer Segmentation">
                           
                            <div class="content">
                                <h3><a href="https://ysg-sa.com/">
                                    YSG-SA</a></h3>
                              
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/20.png"
                                    alt="Detection Project">
                           
                            <div class="content">
                                <h3><a href="https://hisrah.com/"
                                        >HISRAH TECHNOLOGIES
                                        </a></h3>
                          
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                        <div class="case-study-card">
                          
                                <img src="assets/img/case-studies/21.png"
                                    alt="Customer Segmentation">
                           
                            <div class="content">
                                <h3><a href="https://royalinternationalministries.com/">ROYAL INTERNATIONAL MINISTRY
                                        </a></h3>
                                
                            </div>
                        </div>
                    </div>


                </div>

            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-widget-right">
                    <div class="widget-category">
                        <h3>Our Services</h3>

                        <ul>
                            <li><a routerLink="/services">Web
                                    Development</a></li>
                            <li><a routerLink="/services">Android
                                    Application</a></li>
                            <li><a routerLink="/services">IOS
                                    Applications</a></li>
                            <li><a routerLink="/services">IT/E-Governance Support
                                    Consultancy</a></li>
                            <li><a routerLink="/services">Social Media Marketing
                                </a></li>
                            <li><a routerLink="/services">Graphic Designing
                                </a></li>
                            <li><a routerLink="/services"> AI Videos
                                </a></li>
                        </ul>
                    </div>

                    <div class="contact-widget">
                        <h2>Contact Info</h2>

                        <ul>
                            <li>
                                <i class="flaticon-telephone"></i>
                                <div class="content">
                                    <h3>Phone: </h3>
                                    <span><a href="tel:9895373751">+ 91 989 5373
                                            751 </a></span>
                                </div>
                            </li>
                            <li>
                                <i class="flaticon-email-1"></i>
                                <div class="content">
                                    <h3>Email:</h3>
                                    <span><a
                                            href="mailto:ipromisesolutions&#64;gmail.com">ipromisesolutions&#64;<br>gmail.com</a></span>
                                </div>
                            </li>
                            <li>
                                <i class="flaticon-planet-earth"></i>
                                 <div class="col-lg-4 col-md-6">
                <div class="contact-card">
                    <i class="flaticon-planet-earth"></i>
                    <h3>Corp. Office</h3>

                      <p>KSUM (T-TBI) -2, Thejaswini,   </p>
                    <p>Technopark, Thiruvananthapuram </p>
                 
                    <br>
                    <h3>Branch. Office</h3>                 
                     <p>IInd Floor,Penta City Tower,Opp.PRS Hospital </p>
                    <p>Killippalam, Trivandrum, IN</p>
                    
                </div>
            </div>
                            </li>
                        </ul>
                    </div>

                    <div class="services-widget-two" style="display: none;">
                        <h2>Brochures</h2>

                        <ul>
                            <li>
                                <i class="flaticon-pdf-file"></i>
                                <div class="content">
                                    <h3>01:</h3>
                                    <span><a routerLink="#">PDF
                                            Download</a></span>
                                </div>
                            </li>
                            <li>
                                <i class="flaticon-pdf-file"></i>
                                <div class="content">
                                    <h3>02:</h3>
                                    <span><a routerLink="#">Services
                                            Details.txt</a></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="seo-area">
    <div class="container-fluid">
        <div class="seo-width">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <div class="seo-form">
                        <h2>Contact with Our Experts?</h2>

                        <div class="seo-form-area">
                            <app-coming-soon></app-coming-soon>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="seo-img">
                        <img src="assets/img/seo-rank.png" alt="Images">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png"
                        alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png"
                        alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png"
                        alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png"
                        alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png"
                        alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png"
                        alt="Images">
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>